<template>
  <div class="mapContainer">
    <div id="chart2" ref="echart_china2" class="china-map" v-if="!isCityMap"></div><!--大地图-->
    <div id="chart" ref="echart_china" class="show-city-map" v-else></div><!--小地图，左侧有城市地图就显示-->
    <div class="city-map-content" v-show="isCityMap">
      <div class="city-name">
        <span v-if="cityName">
          {{ provinceName }}<i
            v-if="provinceName != '北京' && provinceName != '重庆' && provinceName != '上海' && provinceName != '天津'"
            style="font-style: normal">省</i>
          <i v-else style="font-style: normal">市</i>-{{ cityName }}捐助情况
        </span>
        <!--<span v-else-if="provinceName === '北京' || provinceName === '重庆' || provinceName === '上海' || provinceName === '天津'">{{provinceName}}市捐助情况</span>-->
        <span v-else>{{ provinceName }}<i
            v-if="provinceName != '北京' && provinceName != '重庆' && provinceName != '上海' && provinceName != '天津'"
            style="font-style: normal">省</i>
          <i v-else style="font-style: normal">市</i>捐助情况</span>
      </div>
      <div class="city-map" id="city" ref="echart_city"></div>
      <div class="public-list" ref="public_ref" v-loading.fullscreen.lock="fullscreenLoading">
        <el-timeline>
          <el-timeline-item v-for="item in updatedActionList" :key="item.uuid"
            :timestamp="item.start_event_time ? item.start_event_time : ''" placement="top" type="primary"
            color="#0086FF">
            <el-card>
              <div class="left-content">
                <img :src="item.teacher_info.teacher_image" />
              </div>
              <div class="right-content">
                <div class="teacher-info">
                  <span class="teacher-name">{{ item.teacher_info.name }}</span>
                  <span class="money-info" v-if="item.charity_fund < 10000"><i>{{ item.charity_fund }}</i>元</span>
                  <span class="money-info" v-else><i>{{ (item.charity_fund / 10000).toFixed(2) }}</i>万元</span>
                </div>
                <p>{{ item.address }}</p>
              </div>
            </el-card>
          </el-timeline-item>
          <p v-if="updatedActionList.length === 0" class="noData">暂无数据</p>
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>
import symbolIcon from "@/assets/img/symbolIcon.png";
import mapBgIcon from "@/assets/img/mapbg.png";
import chinamap from "@/assets/json/china.json";
import { EXISTING_SECOND_LAYER_REGION } from './constant';
import { getGeoJson, getMapData } from '@/apis/map'
export default {
  name: "PublicChinaMap",
  data() {
    return {
      data: [
        { name: "河北", value: 102 },
        { name: "江苏", value: 92 },
        { name: "河南", value: 137 },
        { name: "广东", value: 123 },
        { name: "新疆", value: 180 },
      ],
      geoCoordMap: {},
      toolTipData: [
        { name: "河北" },
        { name: "江苏" },
        { name: "河南" },
        { name: "广东" },
        { name: "新疆" },
      ],
      mapName: 'china',
      symbolIcon: symbolIcon,
      mapBgIcon: mapBgIcon,
      isCityMap: false,//小地图
      myChart2: null, // echarts实例 //大地图
      mapStack: [], // 存储地图数据
      timer: null,
      mapChart: null,
      myChart: null, //大地图
      cityName: '',
      provinceName: '',
      selectedProvinceList: [],
      updatedActionList: [],
      page: 0,
      size: 12,
      totalPages: 100,
      current_page: 1,
      noMoreData: false,
      partDataMain: [],
      fullscreenLoading: false,
      currentProvince: "",
      currentCity: "",
    }
  },
  mounted() {
    if (!this.isCityMap) {
      this.myChart2 = this.$echarts.init(this.$refs.echart_china2); //大地图
    } else {
      this.myChart = this.$echarts.init(this.$refs.echart_china); //小地图
    }
    this.addChartEvent();

    var mapFeatures = this.$echarts.getMap(this.mapName).geoJson.features;
    var _this = this;
    mapFeatures.forEach(function (v) {
      // 地区名称
      var name = v.properties.name;
      // 地区经纬度
      _this.geoCoordMap[name] = v.properties.cp;
    });
    this.getSelectedProvince();
    this.$nextTick(() => {
      this.$refs.public_ref.addEventListener('scroll', this.lazyLoading)
    })
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  created() {
    //window.showCityDetail = this.showCityDetail;
  },
  methods: {
    convertData(data) {
      var _this = this;
      var res = [];

      for (var i = 0; i < data.length; i++) {
        var geoCoord = _this.geoCoordMap[data[i].name];
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
            selected: true,
            charity_fund: data[i].charity_fund,
            num: data[i].num
          });
        }
      }
      return res;
    },
    init() {
      this.$echarts.registerMap("china", chinamap);
      // 3. 设置图表 option
      var option = {
        geo: {
          type: "map",
          map: "china", //使用 registerMap 注册的地图名称
        },
      };
      if (!this.isCityMap) {
        this.myChart2.setOption(option);
      } else {
        this.myChart.setOption(option);
      }
    },
    //获取点亮的省份列表数据
    getSelectedProvince() {
      this.$http({
        method: 'get',
        url: '/api/v1/main_station/illuminate/province/',
        headers: {
          'AUTH-SYS': 'admin'
        },
      }).then(res => {
        if (res.data.code === 20000) {
          var dataArray = res.data.data.map(item => {
            if (item.province === '黑龙江省' || item.province === '内蒙古自治区') {
              return {
                name: item.province.substring(0, 3),
                selected: true,
                charity_fund: item.charity_fund,
                num: item.num
              }
            } else {
              return {
                name: item.province.substring(0, 2),
                selected: true,
                charity_fund: item.charity_fund,
                num: item.num
              };
            }
          });
          this.selectedProvinceList = this.convertData(dataArray)
          this.showScatterInGeo();
        }
      })
    },
    showScatterInGeo() {
      var _this = this;
      const option = {
        tooltip: {
          trigger: 'item',
          padding: 0,
          enterable: true,
          transitionDuration: 1,
          triggleOn: 'click',
          textStyle: {
            color: '#000',
            decoration: 'none',
          },
          position: function (point, params, dom, rect, size) {
            return [point[0] - 50, point[1] - 120]  //返回x、y（横向、纵向）两个点的位置
          },
          formatter: function (params) {
            var tipHtml = '';
            if (params.data) {
              var provinceName = `${params.name}`;
              var price = '';
              if (params.data.charity_fund < 10000) {
                price = params.data.charity_fund + '元'
              } else {
                price = (params.data.charity_fund / 10000).toFixed(2) + '万元'
              }
              parseFloat((params.data.charity_fund / 10000).toFixed(2));
              tipHtml = '<div class="tips-map" id="cityDetail" style="width:226px;height:110px;cursor: pointer;position: relative;z-index: 1000000000;">'
                + '<a><div style="width:100%;padding:20px 16px;">'
                + '<span style="font-size:18px;color: #0A0D0F;font-weight: bold;">' + params.name + '</span>'
                + '<i style="margin-left: 10px;color: #FF3939;font-size:18px;font-style: normal;font-weight: bold;">' + price + '</i>'
                + '<p style="color: #434649;font-size:14px;margin-top: 6px;">累计向' + params.name + '捐赠了' + params.data.num + '次' +
                '</p>'
                + '</a></div>';
              /*setTimeout(function() {
                _this.tooltipCharts(params.name);
              }, 10);*/

              setTimeout(function () {
                // Attach the click event handler to the dynamically created element
                document.getElementById('cityDetail').addEventListener('click', function () {
                  // Call the method within your Vue component
                  _this.provinceName = provinceName;
                  _this.showCityDetail(provinceName);
                  _this.isCityMap = true;
                  if (!_this.isCityMap) {
                    // 显示城市地图时，调整容器大小并调用 resize 方法
                    _this.$nextTick(() => {
                      _this.myChart.resize();
                    })
                  } else {
                    // 显示中国地图时，调整容器大小并调用 resize 方法
                    _this.$nextTick(() => {
                      _this.myChart2.resize();
                    })
                  }
                  _this.page = 0;
                  _this.updatedActionList = [];
                  _this.getProvinceDetails(provinceName, '')
                }.bind(this));
              }.bind(this), 0);
              return tipHtml;
            } else {
              return ''
            }


          },
          borderColor: 'rgba(0, 0, 0, 0)',
          extraCssText:
            'background:url(' + _this.mapBgIcon + ') no-repeat center center;width:226px;height:110px;background-size:100% 100%;'
        },
        geo: {
          type: "map",
          map: "china",
          show: true,
          roam: false,
          //zoom: 1,
          width: '50%',
          height: '90%',
          label: {
            normal: {
              show: false,
              color: '#BCCADE',
              textStyle: {
                fontSize: 16 // 设置字体大小
              }
            },
            emphasis: {
              show: false,
              color: '#FFFFFF'
            },
          },
          itemStyle: {
            normal: {
              areaColor: '#FFFFFF',
              borderColor: 'rgba(0,134,255,0.2)',
              borderWidth: 1,
            },
            emphasis: {
              areaColor: '#FFFFFF',
              borderColor: 'rgba(0,134,255,0.2)',
              borderWidth: 1,
            }
          }
        },
        series: [
          {
            type: 'map',
            map: 'china',
            //zoom: 1,
            roam: false,
            zlevel: 2,
            width: '50%',
            height: '90%',
            //selectedMode: 'multiple',
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false,
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#FFFFFF',
                borderColor: 'rgba(0,134,255,0.2)',
                borderWidth: 1,
              },
              emphasis: {
                areaColor: '#E5F3FF',
                borderColor: 'rgba(0,134,255,0.2)',
                borderWidth: 1,
              }
            },
            data: _this.selectedProvinceList
          },
          {
            name: '散点',
            type: 'scatter',
            coordinateSystem: 'geo',
            data: _this.selectedProvinceList,
            symbolSize: 19,
            zlevel: 2,
            hoverAnimation: false,
            label: {
              normal: {
                show: true,
                position: 'right',
                formatter: '{b}',
                offset: [-3, -1],
                textStyle: {
                  fontSize: 14, // 设置字体大小
                  fontWeight: 'bold',
                }
              },
              emphasis: {
                show: true
              }
            },
            symbol: 'image://' + _this.symbolIcon,
            symbolOffset: [-10, 0],
            itemStyle: {
              normal: {
                color: '#FF3939', // 起点颜色
                borderColor: '#FF3939',
              },
            },
          },
          /* {
             type: 'effectScatter',
             coordinateSystem: 'geo',
             showEffectOn: 'render',
             hoverAnimation: true,
             /!*zlevel: 2,*!/
             rippleEffect: {
               period: 4,
               brushType: 'stroke',
               scale: 4,
             },
             //symbol: 'circle',
             symbolSize: 8,
             itemStyle: {
               normal: {
                 color: '#fff',
                 borderColor: '#fff',
                 borderWidth: 2,
               },
             },
             data: _this.convertData(_this.data),
           },*/
        ],
      };
      if (!this.isCityMap) {
        this.myChart2.setOption(option);
      } else {
        this.myChart.setOption(option);
      }

    },
    // 添加绑定事件
    addChartEvent() {
      this.bindResizeWindow() // 监听屏幕大小改变
      this.bindClickChart() // 绑定自定义单击事件
    },
    // 监听屏幕大小改变
    bindResizeWindow() {
      window.addEventListener('resize', () => {
        if (this.timer) return
        this.bindResizeWindow();
        this.timer = setTimeout(() => {
          if (!this.isCityMap) {
            // 显示城市地图时，调整容器大小并调用 resize 方法
            this.myChart2.resize();
          } else {
            // 显示中国地图时，调整容器大小并调用 resize 方法
            this.myChart.resize();
          }
          this.timer = null
        }, 100)
      })
    },
    //点击省份详细信息展示城市地图信息
    async showCityDetail(name) {
      if (EXISTING_SECOND_LAYER_REGION.find(i => i.name === name)) {
        const mapName = `${name}`;
        //this.getProvinceDetails(mapName,'');
        const { partData, geoJson } = await this.getGeoAndMapData('province', mapName)
        this.registeRenderMap(mapName, partData, geoJson)
      }
    },
    lazyLoading(e) {
      const scrollTop = e.target.scrollTop // 滚动条滚动时，距离顶部的距离
      const windowHeight = e.target.clientHeight // 可视区的高度
      const scrollHeight = e.target.scrollHeight // 滚动条的总高度
      // 滚动条到底部.
      if (scrollTop + windowHeight >= scrollHeight) {
        //this.page++
        if (this.page > this.totalPages) return
        this.getProvinceDetails(this.currentProvince, this.currentCity)
      }
    },
    //点击省份展示省份下的详细数据信息
    getProvinceDetails(province, city) {
      this.currentProvince = province;
      this.currentCity = city;
      if (this.page >= this.totalPages) {
        this.noMoreData = true; // 已经加载完所有数据
        return;
      }
      this.fullscreenLoading = true;
      setTimeout(() => {
        this.page++;
        this.$http({
          method: 'get',
          url: '/api/v1/main_station/province/welfare/',
          params: {
            mold: 1,
            page: this.page,
            size: this.size,
            province: province,
            city: city
          },
          headers: {
            'AUTH-SYS': 'admin'
          },
        }).then(res => {
          this.fullscreenLoading = false;
          if (res.data.code === 20000) {
            this.partDataMain = res.data.data.city_list;
            this.totalPages = res.data.data.total_page;
            this.updatedActionList = this.updatedActionList.concat(res.data.data.results);
            if (this.page === this.totalPages) {
              this.noMoreData = true;
            } else {
              this.noMoreData = false;
            }

            this.checkMapData(province)
          }
        })
      }, 500)

    },
    // 绑定自定义单击事件
    bindClickChart() {
      if (this.isCityMap) {
        this.myChart.on('click', async e => {
          const {
            seriesName,
            name,
            data,
          } = e
          this.provinceName = name;
          this.selectedProvinceList.map(item => {
            if (item.name === name) {
              // 可下钻到二级地图（23个省、5个自治区、4个直辖市、2个特别行政区）
              if (EXISTING_SECOND_LAYER_REGION.find(i => i.name === name)) {
                const mapName = `${name}`;
                this.cityName = '';
                this.updatedActionList = [];
                this.page = 0;
                this.getProvinceDetails(mapName, '');
              }
            } else {
              return;
            }
          })

        })
      } else {
        this.myChart2.on('click', async e => {
          const {
            seriesName,
            name,
            data,
          } = e
          this.provinceName = name;
          this.selectedProvinceList.map(item => {
            if (item.name === name) {
              // 可下钻到二级地图（23个省、5个自治区、4个直辖市、2个特别行政区）
              if (EXISTING_SECOND_LAYER_REGION.find(i => i.name === name)) {
                const mapName = `${name}`;
                this.cityName = '';
                this.updatedActionList = [];
                this.page = 0;
                this.getProvinceDetails(mapName, '');
              }
            } else {
              return;
            }
          })
        })
      }

    },
    /**
     * @description: 获取要渲染到地图的值
     * @param {String} type 类型  china：中国地图   province：省级地图   city：市级地图
     * @param {String} mapName 地图名称 同注册地图方法registerMap 的第一个参数一致
     */
    async checkMapData(mapName) {
      const { partData, geoJson } = await this.getGeoAndMapData('province', mapName)
      this.registeRenderMap(mapName, partData, geoJson)
    },
    /**
     * @description: 获取渲染地图的相关数据 geoJson 和 partData（地图部分数据内容）
     * @param {String} type 类型  china：中国地图   province：省级地图   city：市级地图
     * @param {String} mapName 地图名称 同注册地图方法registerMap 的第一个参数一致
     */
    async getGeoAndMapData(type, mapName) {
      const [{ data: geoJson }, res] = await Promise.all([getGeoJson(type, mapName), getMapData(type)])
      const { data: partData } = res.data
      //const partData = this.getProvinceDetails(mapName,'');
      return { geoJson, partData }
    },
    /**
     * @description: 注册渲染地图
     * @param {String} mapName 地图名称 同 option/series/map 一致
     * @param {Array} partData 地图部分数据内容
     * @param {Object} geoJson 地图geoJson
     * @param {Object} specialAreas 特殊区域
     */
    registeRenderMap(mapName, partData, geoJson, specialAreas = {}) {
      // 销毁地图实例
      if (this.mapChart) {
        this.mapChart.dispose();
      }
      // 注册地图
      this.mapChart = this.$echarts.init(this.$refs.echart_city);
      this.isCityMap = true;
      if (!this.isCityMap) {
        //this.myChart2.dispose();
        //this.showScatterInGeo();
        // 显示城市地图时，调整容器大小并调用 resize 方法
        this.$nextTick(() => {
          this.myChart.resize();
        })
      } else {
        //this.myChart.dispose();
        //this.showScatterInGeo();
        // 显示中国地图时，调整容器大小并调用 resize 方法
        this.$nextTick(() => {
          this.myChart2.resize();
        })
      }
      //this.bindResizeWindow();
      this.$echarts.registerMap(mapName, geoJson, specialAreas)
      // 绘制地图
      this.renderMap(mapName, partData, geoJson)
    },
    /**
     * @description: 绘制地图
     * @param {String} mapName 地图名称 同注册地图方法registerMap 的第一个参数一致
     * @param {Array} partData 地图部分数据内容
     * @param {Object} geoJson 地图geoJson
     */
    renderMap(mapName, partData, geoJson) {
      const seriesDataSelect = this.getSeriesDataBySelect(mapName, partData, geoJson)

      const option = {
        tooltip: {
          show: false,
          trigger: 'item',
          formatter: '{b}<br/>{c}',
          backgroundColor: '#de5e60',
          textStyle: {
            color: '#ffe4e5',
            fontSize: 12,
          },
        },
        // 视觉映射
        series: [
          {
            name: mapName, // 系列名称
            type: 'map',
            map: mapName, // 同 registerMap 方法的第一个参数一致
            zoom: 1.5, // 当前视角的缩放比例
            zlevel: 1, // 用于 Canvas 分层，不同zlevel值的图形会放置在不同的 Canvas 中
            roam: true,
            //selectedMode: 'multiple',
            label: {
              normal: {
                show: true,
                position: 'center',
                formatter: function (params) {
                  if (params.seriesName === '重庆' || params.seriesName === '上海' || params.seriesName === '北京' || params.seriesName === '天津') {
                    return '';
                  }
                  // 判断城市是否被选中
                  if (params.data.selected) {
                    // 返回需要显示的值
                    return params.data.name;
                  }
                  // 如果未选中，返回空字符串或其他你希望显示的内容
                  return '';
                },
                textStyle: {
                  fontSize: 14, // 设置字体大小
                  /*fontWeight: 'bold',*/
                  color: '#FF3939',
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: 14, // 设置强调状态下的字体大小
                  color: '#FF3939', // 设置强调状态下的字体颜色
                  /*fontWeight: 'bold',*/
                },
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#FFFFFF',
                borderColor: 'rgba(0,134,255,0.2)',
                borderWidth: 1,
                color: '#FF3939',
              },
              emphasis: {
                show: false,
                areaColor: '#E5F3FF',
                borderWidth: 1,
                borderColor: 'rgba(0,134,255,0.2)',
              }
            },
            data: seriesDataSelect,
          },
        ],
      }
      // 绘制图表
      this.mapChart.setOption(option)
      var _this = this;
      let isEventHandled = false;
      //_this.cityName=''
      this.mapChart.on("click", function (params) {
        _this.cityName = ''
        if (!isEventHandled) {
          isEventHandled = true;
          if (_this.mapChart) {
            _this.mapChart.dispose();
          }
          _this.cityName = params.name;
          //params.event.stopPropagation(); // 阻止事件冒泡
          _this.page = 0;
          _this.updatedActionList = [];
          _this.$nextTick(() => {
            _this.getProvinceDetails(_this.currentProvince, params.name);
          })
        }
      })
    },
    /**
     * @description: 根据partData 和 geoJson 生成 seriesData
     * @param {Array} partData 地图部分数据内容
     * @param {Object} geoJson 地图geoJson
     */
    getSeriesDataByPart(partData, geoJson) {
      let data = geoJson.features.map(({ properties }) => ({
        adcode: properties.adcode,
        name: properties.name,
        value: 0,
      }))
      if (geoJson.attach) {
        const attachData = geoJson.attach.map(item => ({
          adcode: item.adcode,
          name: item.name,
          value: 0,
        }))
        data.push(...attachData)
      }
      // 过滤掉九段线数据
      //data = data.filter(item => item.adcode !== JD_ADCODE)

      data.forEach(item => {
        const currData = partData.find(i => i.name === item.name)
        if (currData) {
          item.value = currData.value
        }
      })
      return data
    },
    getSeriesDataBySelect(mapName, partData, geoJson) {
      let data = geoJson.features.map(({ properties }) => ({
        name: properties.name,
        value: 0,
      }));
      if (geoJson.attach) {
        const attachData = geoJson.attach.map(item => ({
          name: item.name,
          value: 0,
        }));
        data.push(...attachData);
      }
      const directCity = ['北京', '天津', '上海', '重庆']
      let matchData = [];
      data.map((item) => {
        item.selected = false;
        item.value = Math.random() * 100;
        if (directCity.includes(mapName)) {
          item.selected = true;
        }
        if (this.partDataMain.includes(item.name)) {
          item.selected = true;
        }
        matchData.push(item);
      });
      return matchData;
    },
    /**
     * @description: 根据seriesData 动态计算生成 visualMap 的最大值
     * @param {Array} seriesData 地图数据内容
     */
    getVisualMapMax(seriesData) {
      const maxValue = Math.max(...seriesData.map(item => item.value))
      return parseInt(maxValue) + 50
    },
    /**
     * @description: 地图数据入栈，栈顶成员即当前渲染的地图数据
     * @param {String} mapName 地图名称 同注册地图方法registerMap 的第一个参数一致
     * @param {Array} partData 地图部分数据内容
     * @param {Object} geoJson 地图geoJson
     */
    pushStack(mapName, partData, geoJson) {
      this.mapStack.push({
        mapName,
        partData,
        geoJson,
      })
    },
    /**
     * @description: 获取栈顶成员
     */
    topChild() {
      if (this.mapStack.length === 0) return undefined
      return this.mapStack[this.mapStack.length - 1]
    },

    handleClickOutside(event) {
      if (!event.target.closest('.city-map-content')) {
        this.isCityMap = false;
        this.showScatterInGeo();
        var _this = this;
        this.$nextTick(() => {
          _this.myChart2.resize();
        })
      }
    }

  },
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.fxwljy.com/attach/file1706509868982.otf');
}

@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.fxwljy.com/attach/file1706509868791.otf');
}

.mapContainer {
  width: 100%;
  height: 800px;
  position: relative;
}

.china-map {
  width: 100%;
  height: 800px;
}

.show-city-map {
  width: 85%;
  height: 680px;
  margin: 0 auto;
  margin-left: 300px;
  margin-top: 60px;
}

.tips-map {
  background-image: url("../assets/img/mapbg.png") !important;
  background-size: 100% 100%;
  width: 226px;
  height: 110px;
}

.city-map-content {
  width: 500px;
  height: 800px;
  position: absolute;
  left: 100px;
  top: 70px;
  background-color: #FFFFFF;
  border-radius: 16px;

  .city-name {
    width: 100%;
    height: 100px;
    background: #0086FF;
    border-radius: 16px 16px 0px 0px;

    span {
      font-weight: bold;
      font-size: 24px;
      color: #FFFFFF;
      line-height: 100px;
      text-align: left;
      width: 100%;
      height: 100px;
      padding-left: 24px;
      font-family: "SourceHanSansCNBold Microsoft YaHei";
    }
  }

  .public-list {
    margin: 10px auto;
    width: 99%;
    max-height: 370px;
    overflow: hidden;
    overflow-y: auto;

    .noData {
      text-align: center;
      color: #B9BDC4;
      font-size: 18px;
      font-family: "SourceHanSansCN Microsoft YaHei";
      width: 100%;
      height: 30px;
      line-height: 30px;
    }

    ::v-deep .el-timeline {
      padding-top: 15px;
    }

    ::v-deep .el-timeline-item__node--primary {
      /*border-color: #0086FF;
      transition: all 0.3s linear;*/
      background-color: transparent !important;
      background: url("../assets/img/dot.png") no-repeat;
      background-size: 100% 100%;
      height: 15px;
      width: 15px;
    }

    ::v-deep .el-timeline-item__node--normal {
      left: 20px !important;
    }

    ::v-deep .el-timeline-item__tail {
      border-left: 1px dashed rgba(144, 146, 149, 0.4);
      /*border-spacing: 10px;
      border-left-width: 2px;*/
      height: 108px;
      top: 30px;
      left: 27px;
    }

    ::v-deep .el-timeline .el-timeline-item:last-child .el-timeline-item__tail {
      display: block;
    }

    ::v-deep .el-timeline .el-timeline-item:last-child .el-timeline-item__wrapper .is-always-shadow {
      border-bottom: none;
    }

    ::v-deep .el-card.is-always-shadow,
    .el-card.is-hover-shadow:focus,
    .el-card.is-hover-shadow:hover {
      box-shadow: none;
      /*border-radius: 16px;*/
      border-radius: 0;
      border: none;
    }

    ::v-deep .el-card__body {
      display: flex;
      justify-content: center;
      padding: 0;
      height: 108px;
      background: #F5F7FA;
      border-radius: 8px;
      width: 440px;
      align-items: center;
    }

    ::v-deep .el-timeline-item__wrapper {
      margin-bottom: 10px;
      padding-left: 40px;
    }

    ::v-deep .el-timeline-item__timestamp.is-top {
      margin-bottom: 15px;
      font-size: 16px;
      font-family: HarmonyOS_Sans_SC;
      color: #909295;
      padding-top: 2px;
      padding-left: 7px;
    }

    .left-content {
      width: 68px;
      height: 68px;
      margin-left: 12px;
      border-radius: 8px;
      background-image: url("../assets/img/headerImg.png");
      background-size: contain;

      img {
        border-radius: 8px;
        width: 68px;
        height: 68px;
        object-fit: cover;
      }
    }

    .right-content {
      flex: 1;
      position: relative;
      margin-left: 12px;

      .teacher-info {
        display: flex;
        height: 30px;
        margin-bottom: 10px;

        .teacher-name {
          font-family: "SourceHanSansCN Microsoft YaHei";
          font-weight: bold;
          font-size: 20px;
          color: #0A0D0F;
          line-height: 30px;
          text-align: left;
        }

        .money-info {
          font-weight: 400;
          font-size: 16px;
          color: #0A0D0F;
          line-height: 24px;
          text-align: left;
          margin-left: 5px;
          font-family: "SourceHanSansCN Microsoft YaHei";

          i {
            font-style: normal;
            font-size: 20px;
            font-family: 'numberFamily';
            color: #FF3939;
            font-weight: bold;
            line-height: 30px;
            margin-right: 5px;
          }
        }
      }

      p {
        font-weight: 400;
        font-size: 16px;
        color: #434649;
        line-height: 24px;
        text-align: left;
        font-family: "SourceHanSansCN Microsoft YaHei";
      }
    }
  }
}

.city-map {
  margin: 10px auto;
  width: 476px;
  height: 300px;
  background: #F5F7FA;
  border-radius: 8px;
}

::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: #B9BDC4;
  border-radius: 8px;
}

::-webkit-scrollbar-thumb:hover {
  background: #B9BDC4;
}

::-webkit-scrollbar-track {
  background-color: #FFFFFF;
  border: 0;
}
</style>